module.exports = __webpack_public_path__ + "static/media/Katty-Lynch-Serif.da0e73ae.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Katty-Lynch-Serif.eot
// module id = 2939
// module chunks = 70